module.exports = __webpack_public_path__ + "static/media/gm.e0a547e7.png";